enum EventTagEnum {
  'Oficial' = 'aqua',
  'Comunidad' = 'green',
  'General' = 'orange'
}

export default EventTagEnum;